export default __webpack_public_path__ + "static/media/excel-green.cd830e77.svg";